import React from 'react';
import { CSSTransition } from 'react-transition-group';
import Modal from '../../components/commons/modal';
import './index.scss';

export const MapModalContainer = ({
  children,
  isModalOpen,
  close,
  classname,
}) => {
  return (
    <CSSTransition
      in={isModalOpen}
      timeout={500}
      classNames="full-map__modal"
      unmountOnExit
    >
      <Modal hasScroll={false} close={close} className={classname}>
        {children}
      </Modal>
    </CSSTransition>
  );
};
